import { ReactNode } from 'react';
import styled from 'styled-components';

interface IProps {
  jsContent?: string;
  allItems?: string;
  flexWrap?: string;
  flexColumn?: string;
  gap?: number;
  children?: ReactNode;
}

const StyledFlex = styled.div<IProps>`
  display: flex;
  justify-content: ${(props) => props.jsContent || 'flex-start'};
  align-items: ${(props) => props.allItems || 'flex-start'};
  flex-wrap: ${(props) => props.flexWrap || 'nowrap'};
  flex-direction: ${(props) => props.flexColumn || 'row'};
  gap: ${(props) => `${props.gap}px` || '0'};
  @media (max-width: 766px) {
    display: block;
  }
`;

export const Flex = (props: IProps) => {
  return <StyledFlex {...props}>{props.children}</StyledFlex>;
};
